import React from 'react';

export const MentionElement = ({ attributes, children, element }) => {
  return (
    <span
      {...attributes}
      contentEditable={false}
      style={{
        padding: '2px 4px',
        margin: '0 1px',
        backgroundColor: '#EAF4FF',
        borderRadius: '4px',
        fontWeight: 500,
        color: '#007aff',
      }}
    >
      @{element.value}
      {children}
    </span>
  );
};
